import { declineName } from '@/lib/content/declension';

/**
 * Generate quiz questions based on country data
 * @param {Object} countryData - Country data object
 * @param {string} lang - Current language (ru/en)
 * @returns {Array} Array of question objects
 */
export function generateQuestions(countryData, _lang) {
    const countryName = countryData?.nameRu || countryData?.name || 'страны';
    const countryNameEn = countryData?.nameEn || countryData?.name || 'country';
    const countryNamePrep = declineName(countryName, 'prepositional');

    return [
        {
            id: 0,
            question: {
                ru: 'Где вы будете пользоваться eSIM?',
                en: 'Where will you use your eSIM?'
            },
            options: {
                ru: [`Только в ${countryNamePrep}`, `В ${countryNamePrep} и соседних странах`],
                en: [`Only in ${countryNameEn}`, `In ${countryNameEn} and neighboring countries`]
            },
            multipleChoice: false
        },
        {
            id: 1,
            question: {
                ru: 'Сколько дней вы проведёте в поездке?',
                en: 'How long will your trip last?'
            },
            options: {
                ru: ['1-7 дней', '8-15 дней', '16-30 дней', 'Более 30 дней'],
                en: ['1-7 days', '8-15 days', '16-30 days', '30+ days']
            },
            multipleChoice: false
        },
        {
            id: 2,
            question: {
                ru: 'Сколько трафика вам понадобится?',
                en: 'How much data do you need?'
            },
            options: {
                ru: ['До 5 ГБ', '5-20 ГБ', 'Более 20 ГБ', 'Безлимит', 'Не знаю'],
                en: ['Up to 5 GB', '5-20 GB', '20+ GB', 'Unlimited', 'Not sure']
            },
            multipleChoice: false
        },
        {
            id: 3,
            question: {
                ru: 'Важно ли, чтобы сайт оператора был на русском языке?',
                en: null
            },
            options: {
                ru: ['Да, русский необходим', 'Нет, подойдёт английский'],
                en: null
            },
            multipleChoice: false,
            ruOnly: true
        }
    ];
}

/**
 * Generate translations based on country data
 * @param {Object} countryData - Country data object
 * @param {string} lang - Current language (ru/en)
 * @returns {Object} Translations object with ru and en keys
 */
export function generateTranslations(countryData, _lang) {
    const countryName = countryData?.nameRu || countryData?.name || 'страны';
    const countryNameEn = countryData?.nameEn || countryData?.name || 'country';
    const countryNameGen = declineName(countryName, 'genitive');

    return {
        ru: {
            title: 'Подбор eSIM',
            subtitle: `Найдите идеальный тариф eSIM для ${countryNameGen}`,
            question: 'Вопрос',
            of: 'из',
            multipleChoice: 'Выберите один или несколько вариантов',
            next: 'Далее',
            back: 'Назад',
            selectAtLeastOne: 'Пожалуйста, выберите хотя бы один вариант',
            results: 'Подходящие тарифы eSIM',
            noResults: 'К сожалению, подходящие тарифы не найдены',
            noResultsDesc: 'Попробуйте изменить параметры поиска',
            startOver: 'Начать заново',
            showAll: 'Показать больше тарифов',
            showFiltered: 'Показать только подходящие',
            backToEsim: 'Назад к eSIM',
            loading: 'Ищем подходящие тарифы...',
            cancel: 'Отмена',
            finish: 'Показать результаты',
            provider: 'Провайдер',
            data: 'Данные',
            validity: 'Срок действия',
            price: 'Цена',
            features: 'Особенности',
            buyNow: 'Купить',
            learnMore: 'Подробнее',
            sortBy: 'Сортировать по',
            sortByPrice: 'Цене',
            sortByData: 'Объему данных',
            sortByValidity: 'Сроку действия',
            sortByRelevance: 'Релевантности',
            unlimited: 'Безлимит',
            days: 'дней',
            gb: 'ГБ'
        },
        en: {
            title: 'eSIM Finder',
            subtitle: `Find the perfect eSIM plan for ${countryNameEn}`,
            question: 'Question',
            of: 'of',
            multipleChoice: 'Select one or more options',
            next: 'Next',
            back: 'Back',
            selectAtLeastOne: 'Please select at least one option',
            results: 'Matching eSIM Plans',
            noResults: 'Sorry, no matching plans found',
            noResultsDesc: 'Try adjusting your search criteria',
            startOver: 'Start Over',
            showAll: 'Show More Plans',
            showFiltered: 'Show Only Matching',
            backToEsim: 'Back to eSIM',
            loading: 'Finding matching plans...',
            cancel: 'Cancel',
            finish: 'Show Results',
            provider: 'Provider',
            data: 'Data',
            validity: 'Validity',
            price: 'Price',
            features: 'Features',
            buyNow: 'Buy Now',
            learnMore: 'Learn More',
            sortBy: 'Sort by',
            sortByPrice: 'Price',
            sortByData: 'Data Amount',
            sortByValidity: 'Validity Period',
            sortByRelevance: 'Relevance',
            unlimited: 'Unlimited',
            days: 'days',
            gb: 'GB'
        }
    };
}

